import React, { useState } from "react";
import Ash_Form from "./ash_Form/Ash_Form";
import Ash_table from "./ash_table/Ash_table";


function Ash({ onNext, onCancel }) {
  return (
    <section className="Imperiality">
      <div className="imperiality_Form_div">
        <Ash_Form onCancel={onCancel} onNext={onNext}/>
      </div>

      <div className="imperiality_table_div">
        <Ash_table />
      </div>
    </section>
  );
}

export default Ash;
